var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkxWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.465 236H249.533C242.059 236 236 242.059 236 249.533V425.465C236 432.94 242.059 438.999 249.533 438.999H425.465C432.94 438.999 438.999 432.94 438.999 425.465V249.533C438.999 242.059 432.94 236 425.465 236ZM628.552 438.999H452.62C445.145 438.999 439.086 445.058 439.086 452.532V628.464C439.086 635.938 445.145 641.997 452.62 641.997H628.552C636.026 641.997 642.085 635.938 642.085 628.464V452.532C642.085 445.058 636.026 438.999 628.552 438.999ZM655.532 236H831.464C838.938 236 844.997 242.059 844.997 249.533V425.465C844.997 432.94 838.938 438.999 831.464 438.999H655.532C648.057 438.999 641.998 432.94 641.998 425.465V249.533C641.998 242.059 648.057 236 655.532 236ZM425.465 641.998H249.533C242.059 641.998 236 648.057 236 655.532V831.464C236 838.938 242.059 844.997 249.533 844.997H425.465C432.94 844.997 438.999 838.938 438.999 831.464V655.532C438.999 648.057 432.94 641.998 425.465 641.998ZM655.532 641.998H831.464C838.938 641.998 844.997 648.057 844.997 655.532V831.464C844.997 838.938 838.938 844.997 831.464 844.997H655.532C648.057 844.997 641.998 838.938 641.998 831.464V655.532C641.998 648.057 648.057 641.998 655.532 641.998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkxWalletIcon);
export default __webpack_public_path__ + "static/media/okx-wallet-icon.455132d905f5cf92bc2af880aa45501d.svg";
export { ForwardRef as ReactComponent };